import { render } from "./TestWhatsappButton.vue?vue&type=template&id=365947f5&scoped=true"
import script from "./TestWhatsappButton.vue?vue&type=script&lang=js"
export * from "./TestWhatsappButton.vue?vue&type=script&lang=js"

import "./TestWhatsappButton.vue?vue&type=style&index=0&id=365947f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365947f5"]])

export default __exports__